import React from 'react';
import PropTypes from 'prop-types';
import css from '../Apps.css';

export const DuplicateLongnameMessage = ({ details, onJumpToDuplicateSite, onRestoreDuplicateSite }) => {
    if (!details) {
        return null;
    }

    if (details.appName) {
        return (
            <span className={css.saveError}>
                Unable to save changes! An{' '}
                <button type="button" className={css.inlineLinkButton} onClick={() => onJumpToDuplicateSite(details)}>
                    app site
                </button>{' '}
                with the bundle identifier &quot;{details.longname}&quot; already exists. Instead of adding a new app site, update the existing
                one.
            </span>
        );
    }

    return (
        <span className={css.saveError}>
            Unable to save changes! An app site with the bundle identifier &quot;{details.longname}&quot; already exists, however it has been previously
            removed from the screen.{' '}
            <button type="button" className={css.inlineLinkButton} onClick={() => onRestoreDuplicateSite(details)}>
                Click here
            </button>{' '}
            to restore it.
        </span>
    );
};

DuplicateLongnameMessage.propTypes = {
    details: PropTypes.shape({
        appId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        appName: PropTypes.string,
        developmentStatus: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        longname: PropTypes.string,
        siteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    onJumpToDuplicateSite: PropTypes.func.isRequired,
    onRestoreDuplicateSite: PropTypes.func.isRequired,
};
